import { Doughnut } from "react-chartjs-2";

const KnobChart = ({ data, type, centerText }) => {
  return (
    <div className="nk-iv-wg-5 position-relative">
      <Doughnut
        data={data}
        options={{
          legend: {
            display: false,
          },
          // rotation: 1 * Math.PI,
          // circumference: type === "half" ? 1 * Math.PI : 2 * Math.PI,
          cutoutPercentage: 93,
          maintainAspectRatio: false,
          hover: false,
          tooltips: {
            enabled: false,
          },
          responsive: true,
        
        }}
      />
      <div className={`nk-iv-wg5-ck-result ${type === "full" ? "pb-4" : ""} position-absolute`}>
        <div className="text-lead">{centerText}</div>
      </div>
    </div>
  );
};

export default KnobChart;
